// extracted by mini-css-extract-plugin
export var currencyInput = "_ka-1";
export var currencySymbol = "_ka-0";